import React, { ReactNode } from 'react';

import './UserListItem.scss';

export type UserListItemProps = {
  children: ReactNode;
  picture: ReactNode;
  alignTop?: boolean;
};

export class UserListItem extends React.PureComponent<UserListItemProps> {
  render() {
    const { picture, children, alignTop } = this.props;

    return (
      <li
        className={`jg-pages-userlistitem${
          alignTop ? ' jg-pages-userlistitem--aligntop' : ''
        }`}
      >
        <div className="jg-pages-userlistitem-avatar">{picture}</div>
        <div className="jg-pages-userlistitem-content jg-flex-g1">
          {children}
        </div>
      </li>
    );
  }
}

export default UserListItem;
